var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_div_2" },
    [
      _c(
        "div",
        {
          staticStyle: { display: "inline" },
          on: { click: _vm.assignToWorkflow }
        },
        [
          _vm._t("default", function() {
            return [
              _c(
                "a",
                {
                  staticStyle: { float: "right" },
                  attrs: { title: "选择工作流[5]" }
                },
                [_vm._v("工作流")]
              )
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            top: "5vh",
            modal: false,
            title: "选择工作流",
            visible: _vm.dialogVisible,
            width: "75%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            opened: _vm.loadMyWorkflow
          }
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", overflow: "scroll" },
              attrs: {
                data: _vm.workflowList,
                border: "",
                "highlight-current-row": "",
                height: "80vh"
              }
            },
            [
              _c("el-table-column", { attrs: { type: "index" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "ID" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [_vm._v(_vm._s(scope.row.id))]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Name" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [_vm._v(_vm._s(scope.row.name))]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Description" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [_vm._v(_vm._s(scope.row.description))]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.selectWorkflow(scope)
                              }
                            }
                          },
                          [_vm._v("选择")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            attrs: {
                              target: "_blank",
                              href:
                                "/ticket/activiti_model_viewer?modelId=" +
                                scope.row.id
                            }
                          },
                          [_vm._v("查看")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45ef04f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ef04f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/AssignToWorkflowDialog.vue
// module id = 786
// module chunks = 75